import styled from 'styled-components';

import Button from '@material-ui/core/Button';
import tokens from 'tokens';

export const StyledButton = styled(Button)`
  background-color: ${tokens.colorBrandprimary};
  color: ${tokens.colorBodynegative};
  &:hover {
    background-color: ${tokens.colorBrandprimaryhover};
    color: ${tokens.colorBodynegative};
  }
  &:disabled {
    background-color: ${tokens.colorGray05};
  }
`;

export const ErrorMessage = styled.div`
  font-size: 14px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: flex-start;
  color: red;
  min-height: 24px;
  flex-wrap: wrap;

  svg {
    min-width: 20px;
    margin-top: 2px;
  }
`;

export const ErrorText = styled.span`
  font-family: Calibre-Regular, sans-serif;
  font-size: 16px;
  font-weight: 400;
`;

export const ErrorLinksContainer = styled.span`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 0;
  flex-wrap: wrap;

  a {
    text-decoration: none;
  }
`;
